/* import __COLOCATED_TEMPLATE__ from './stage-details.hbs'; */
import Component from '@glimmer/component';
import FilterConstants from '../../filter-constants';
import { formatFieldValue } from '../../utils/format';
import type StageDetailResults from '../../models/results/sub-results/stage-details';

interface StageFigureDetailsArgs {
  model: StageDetailResults;
  options: { xscale: string; yscale: string };
}

export default class StageFigureDetails extends Component<StageFigureDetailsArgs> {
  get hasActualStage(): boolean {
    return this.args.model.actualStage !== null;
  }

  get filterName(): string {
    const value = this.args.model.filterName;
    return value.split('_').join('-');
  }

  get nthOrder(): string {
    const value = this.args.model.nthOrder;
    return value.split('_').join('-');
  }

  get implementation(): string | null {
    const value = this.args.model.implementation;
    let result = null;
    switch (value) {
      case FilterConstants.implementationType.sallenKey:
        result = 'sallen-key';
        break;
      case FilterConstants.implementationType.multipleFeedback:
      case FilterConstants.implementationType.deliyannisFriend:
        result = 'multiple-feedback';
        break;
      case FilterConstants.implementationType.inductor:
        result = 'inductor';
        break;
      case FilterConstants.implementationType.gain:
        result = 'gain';
        break;
      case FilterConstants.implementationType.firstOrder:
        result = 'buffered-rc';
        break;
    }
    return result;
  }

  get simulatedGain(): string | null {
    let value = null;
    const gain = this.args.model.gain;
    if (gain.simulatedFrom !== null) {
      value = formatFieldValue(gain.simulatedFrom, FilterConstants.fieldTypes.NumericDecimal, '3s');
    } else if (gain.simulatedValue !== null) {
      value = formatFieldValue(gain.simulatedValue, FilterConstants.fieldTypes.NumericDecimal, '3s');
    }
    return value;
  }

  get simulatedGainTo(): string | null {
    let value = null;
    const gain = this.args.model.gain;
    if (gain.simulatedTo !== null) {
      value = formatFieldValue(gain.simulatedTo, FilterConstants.fieldTypes.NumericDecimal, '3s');
    }
    return value;
  }

  get simulatedFp(): string | null {
    let value = null;
    const stageFp = this.args.model.stageFp;
    if (stageFp.simulatedFrom !== null) {
      value = formatFieldValue(stageFp.simulatedFrom, FilterConstants.fieldTypes.Engineering, '3s');
    } else if (stageFp.simulatedValue !== null) {
      value = formatFieldValue(stageFp.simulatedValue, FilterConstants.fieldTypes.Engineering, '3s');
    }
    return value;
  }

  get simulatedFpTo(): string | null {
    let value = null;
    const stageFp = this.args.model.stageFp;
    if (stageFp.simulatedTo !== null) {
      value = formatFieldValue(stageFp.simulatedTo, FilterConstants.fieldTypes.Engineering, '3s');
    }
    return value;
  }

  get simulatedQ(): string {
    let value = null;
    const stageQ = this.args.model.stageQ;
    if (stageQ.simulatedFrom !== null && stageQ.enabled) {
      value = formatFieldValue(stageQ.simulatedFrom, FilterConstants.fieldTypes.Engineering, '3s');
    } else if (stageQ.simulatedValue !== null && stageQ.enabled) {
      value = formatFieldValue(stageQ.simulatedValue, FilterConstants.fieldTypes.Engineering, '3s');
    } else {
      value = 'N/A';
    }
    return value;
  }

  get simulatedQTo(): string | null {
    let value = null;
    const stageQ = this.args.model.stageQ;
    if (stageQ.simulatedTo !== null) {
      if (stageQ.enabled) {
        value = formatFieldValue(stageQ.simulatedTo, FilterConstants.fieldTypes.Engineering, '3s');
      } else {
        value = 'N/A';
      }
    }
    return value;
  }
}
